import { PageLoading } from 'components';
import { useAiSong } from './hooks';
import SongDetails from './SongDetails';

interface Props {
  id: string;
}

const AISongDetailsContainer = ({ id }: Props) => {
  const { song, isLoading } = useAiSong(id);

  if (isLoading || !song) {
    return <PageLoading />;
  }

  return <SongDetails song={song} />;
};

export default AISongDetailsContainer;
